// Controllers
import environmentCtrl from 'fc-ctrl-environment'
import assetsCtrl from 'fc-ctrl-assets'
import jobsCtrl from 'fc-ctrl-sampling-jobs'
import pointsCtrl from 'fc-ctrl-sampling-points'
import gridsCtrl from 'hfty-ctrl-grid'

// Effect Managers
import { call, select, put, takeEvery, all } from 'redux-saga/effects'

// Selectors
import { updateCurrentSeason } from 'hfty-seasons'
import { firstAvailableGrowerId$ } from 'fc-assets'
import jobsFiltered$ from 'hfty-soil-jobs/src/selectors/jobsFiltered'

// Constants
import {
  PROP_HEFTY_SELECTED_SEASON,
} from 'fc-model-environment/src/constants'
import {
  MANAGEMENT_ZONES,
  FIELD,
} from 'fc-model-assets/src/constants'
import {
  TYPE_AGPHD_SOILS,
} from 'fc-model-sampling-jobs'

// Responsible for fetching the fields based on the farm and season
// variables stored in environment
export default function *watchEnvironmentReceived (): Generator<*, *, *> {
  yield takeEvery(environmentCtrl.actionTypes.receive(), updateEnvironment)
}

function *updateEnvironment ({ payload }) {
  let newSeason = null
  const { data } = payload

  if (data[PROP_HEFTY_SELECTED_SEASON]) {
    newSeason = Number(data[PROP_HEFTY_SELECTED_SEASON].value)
  }
  const grower = yield select(firstAvailableGrowerId$)
  const jobsFiltered = yield select(jobsFiltered$)
  if (newSeason && (newSeason !== jobsFiltered.season)) {
    yield put(updateCurrentSeason(newSeason))
    yield call(fetchAssets, newSeason, grower)
  }
}

function *fetchAssets (season, rootAsset) {
  if (rootAsset && season) {
    yield all([
      call(assetsCtrl.read, {
        queryParams: {
          shape: 'True',
          category: FIELD,
          rootAsset,
          season,
        },
      }),
      call(assetsCtrl.read, {
        queryParams: {
          category: MANAGEMENT_ZONES,
          rootAsset,
          season,
        },
      }),
      call(jobsCtrl.read, {
        queryParams: {
          rootAsset,
          season,
          type: TYPE_AGPHD_SOILS,
        },
      }),
      call(pointsCtrl.read, {
        queryParams: {
          rootAsset,
          season,
        },
      }),
      call(gridsCtrl.read, {
        queryParams: {
          rootAsset,
          season,
        },
      }),
    ])
  }
}
